import styled from 'styled-components';

export const MainContainer = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Footer = styled.div`
  margin: 0;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.43;
  letter-spacing: 0.01071em;
  text-align: center;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 64px;
  margin-bottom: 32px;

  display: flex;
  justify-content: center;
  gap: 5px;
`;
